var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.data.name)+" ")]),_c('v-card-text',[_c('v-layout',{attrs:{"flex-column":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('calendar.eventCard.start'))+": "+_vm._s(_vm.data.start))]),_c('span',[_vm._v(_vm._s(_vm.$t('calendar.eventCard.end'))+": "+_vm._s(_vm.data.end))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }